module.exports = {
  WITHBUYBACK: 'with-buy-back',
  WITHOUTBUYBACK: 'without-buy-back',
  RENT: 'rent',
  LEASYS: 'leasys',
  PURCHASE: 'purchase',
  LEASE: 'lease',
  SUBRENTAL: 'subrental',
  CARSHARING: 'carsharing',
};
